// Stations
import { getStations } from './getStations';
import { updateStations } from './updateStations';

// Filtered stations
import { updateStationsFilter } from './updateStationsFilter';
import { getFilteredStations } from './getFilteredStations';
import { updateFilteredStations } from './updateFilteredStations';
import { updateFilteredStationsLoadingStatus } from './updateFilteredStationsLoadingStatus';
import { resetFilteredStations } from './resetFilteredStations';

// Selected stations
import { getSelectedStationPrices } from './getSelectedStationPrices';
import { getSelectedStation } from './getSelectedStation';
import { updateSelectedStation } from './updateSelectedStation';
import { resetSelectedStation } from './resetSelectedStation';

// Favourite stations
import { getFavouriteStations } from './getFavouriteStations';
import { addFavouriteStations } from './addFavouriteStations';
import { deleteFavouriteStations } from './deleteFavouriteStations';
import { resetDeleteFavouriteStationsStatus } from './resetDeleteFavouriteStationsStatus';
import { updateAddingFavouriteStationsStatus } from './updateAddingFavouriteStationsStatus';

// Visible stations
import { updateVisibleStations } from './updateVisibleStations';
import { updateVisibleStationsDisplay } from './updateVisibleStationsDisplay';

// Price report
import { getStationsPriceReport } from './getStationsPriceReport';
import { createStationsPriceReport } from './createStationsPriceReport';
import { downloadStationsPriceReport } from './downloadStationsPriceReport';
import { getStationsPriceReportSettings } from './getStationsPriceReportSettings';
import { updateStationsPriceReportSettings } from './updateStationsPriceReportSettings';
import { deleteStationsPriceReportSettings } from './deleteStationsPriceReportSettings';
import { resetStationsPriceReportSettings } from './resetStationsPriceReportSettings';
import { resetStationsPriceReport } from './resetStationsPriceReport';
import { updateStationsPriceSettingsUpdatingStatus } from './updateStationsPriceSettingsUpdatingStatus';

// Selected station on the map
import { updateSelectedStationOnMap } from './updateSelectedStationOnMap';
import { resetSelectedStationOnMap } from './resetSelectedStationOnMap';

export const stationsOperations = {
  // Stations
  getStations,
  updateStations,

  // Filtered stations
  getFilteredStations,
  updateStationsFilter,
  updateFilteredStations,
  updateFilteredStationsLoadingStatus,
  resetFilteredStations,

  // Selected stations
  getSelectedStation,
  updateSelectedStation,
  resetSelectedStation,
  getSelectedStationPrices,

  // Selected station on map
  updateSelectedStationOnMap,
  resetSelectedStationOnMap,

  // Favourite stations
  getFavouriteStations,
  addFavouriteStations,
  deleteFavouriteStations,
  resetDeleteFavouriteStationsStatus,
  updateAddingFavouriteStationsStatus,

  // Visible stations
  updateVisibleStations,
  updateVisibleStationsDisplay,

  // Price report
  getStationsPriceReport,
  createStationsPriceReport,
  downloadStationsPriceReport,
  getStationsPriceReportSettings,
  updateStationsPriceReportSettings,
  deleteStationsPriceReportSettings,
  updateStationsPriceSettingsUpdatingStatus,
  resetStationsPriceReportSettings,
  resetStationsPriceReport
};
